var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.env == 'development' && _vm.login)?_c('router-view'):(
      _vm.login ||
        _vm.$route.path == '/login' ||
        _vm.$route.path == '/nodd' ||
        _vm.$route.path.includes('/teach') ||
        _vm.$route.path.includes('/evaluation360')
    )?_c('router-view'):_vm._e(),_c('div',{staticStyle:{"height":"0px"},attrs:{"id":"offsetInfo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }